export default __webpack_public_path__ + "static/media/tab-content-image-03.05fe5e2e.png";